const checkTimeStampLoggedUser = (exp) => {
  if (!exp) return false;
  const expTime = new Date(exp).getTime(); // milisegundos
  const now = Date.now(); // milisegundos
  return now < expTime;
};

export default checkTimeStampLoggedUser;
